export enum FeeType {
    APPRAISAL = "Appraisal Fee",
    CREDIT_REPORT = "Credit Report Fee",
    LOAN_ORIGINATION = "Loan Origination Fee",
    INSPECTION = "Inspection Fee",
    FINAL_REINSPECTION = "Final Reinspection Fee",
    RECORDING = "Recording Fee",
    PROCESSING = "Processing Fee",
    CLOSING = "Settlement or Closing Fee",
    TITLE_ENDORSEMENT = "Title Endorsment Fee",
    TITLE_SERVICES = "Title Services",
    POINTS = "Mortgage Points",
    TITLE_FEES = "Title Fees",
    TOTAL_THIRD_PARTY = "Total Third Party",
    TOTAL_LENDER_FEES = "Total Lender Fees",
    TAXES = "Taxes",
    INSURANCE = "Insurance",
    CONSTRUCTION_INSPECTION = "Insurance",
};